import { Button } from 'tio-ui/components/buttons';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import TioPageBreadcrumbs from 'tio-common/components/tio/page/breadcrumbs';
import transitionTo from 'ember-router-helpers/helpers/transition-to';
import { Header, HStack, Section, VStack } from 'tio-ui/components/layout';
import { PhCheck } from 'ember-phosphor-icons';

<template>
  <TioPageBreadcrumbs class="mb-4" as |b|>
    <b.crumb @route="authenticated.syf.dashboard" @label="Dashboard" />
    <b.crumb @route="authenticated.syf.insights.pslf" @label="PSLF" />
  </TioPageBreadcrumbs>
  <Header>{{t "syf.insights.pslf.heading"}}</Header>
  <Section>
    <:body>
      <HStack>
        <VStack class="w-full md:w-1/2">
          <h2 class="text-lg font-semibold">{{t "syf.insights.pslf.explore.heading"}}</h2>
          <p>{{t "syf.insights.pslf.explore.one" htmlSafe=true}}</p>
          <p>{{t "syf.insights.pslf.explore.two"}}</p>
        </VStack>
        <VStack class="w-full md:w-1/2">
          <h2 class="text-lg font-semibold">{{t "syf.insights.pslf.best_options.heading"}}</h2>
          <div class="flex gap-2 items-start">
            <PhCheck @size="24" class="text-green-700" />
            <p>{{t "syf.insights.pslf.best_options.one"}}</p>
          </div>
          <div class="flex gap-2 items-start">
            <PhCheck @size="16" class="text-green-700 flex-none" />
            <p>{{t "syf.insights.pslf.best_options.two"}}</p>
          </div>
          <div class="flex gap-2 items-start">
            <PhCheck @size="24" class="text-green-700" />
            <p>{{t "syf.insights.pslf.best_options.three"}}</p>
          </div>
          <div class="flex gap-2 items-start">
            <PhCheck @size="16" class="text-green-700 flex-none" />
            <p>{{t "syf.insights.pslf.best_options.four"}}</p>
          </div>
          <hr />
          <div class="flex gap-2 items-start">
            <p class="text-red-600 font-extrabold">&excl;</p>
            <p class="font-bold">{{t "syf.insights.pslf.best_options.action"}}</p>
          </div>
          <div>{{t "syf.insights.pslf.best_options.label"}}</div>
          <Button
            @intent="primary"
            @appearance="outlined"
            {{on "click" (transitionTo "authenticated.idr")}}
          >
            {{t "syf.insights.pslf.best_options.button"}}
          </Button>
        </VStack>
      </HStack>
    </:body>
  </Section>
</template>
